import { Box, Typography } from "@mui/material";
import React from "react";
import AcxDisclosure from "components/UI/AcxDisclosure";

type Props = {
    toolCall: Record<string, unknown>;
    index: number;
};

export const getToolCallName = (
    toolCall: Record<string, unknown>,
): string => {
    const toolFunction = toolCall.function;
    if (
        toolFunction &&
        typeof toolFunction === "object" &&
        "name" in toolFunction &&
        typeof toolFunction.name === "string"
    ) {
        return toolFunction.name;
    }

    return "Tool call";
};

const AgentSkillToolCallDisclosure: React.FC<Props> = ({
    toolCall,
    index,
}) => {
    const toolName = getToolCallName(toolCall);

    return (
        <AcxDisclosure
            id={`agent-skill-tool-call-${index}`}
            summary={
                <Typography variant="body2" fontWeight={600}>
                    {toolName}
                </Typography>
            }
        >
            {toolCall.arguments != null ? (
                <Box
                    component="pre"
                    sx={{
                        m: 0,
                        whiteSpace: "pre-wrap",
                        overflowWrap: "anywhere",
                        fontSize: "0.75rem",
                    }}
                >
                    {JSON.stringify(toolCall.arguments, null, 2)}
                </Box>
            ) : (
                <Typography variant="body2" color="text.secondary">
                    No parameters.
                </Typography>
            )}
        </AcxDisclosure>
    );
};

export default AgentSkillToolCallDisclosure;
